<com-form-input
  (inputFocus)="onShowHint()"
  (inputFocusOut)="checkData()"
  [control]="control"
  [step]="true"
  [showHint]="showHint"
  [hint]="hint"
  type="time"
></com-form-input>
